module.exports = __webpack_public_path__ + "static/media/Apple Watch 44mm Space Grey Aluminum + Black Closed.629223d9.png";